"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openUserProfileLink = exports.openResearchPlatformEvolution = exports.openProfileValidationLink = exports.openPhoneValidationLink = exports.openLink = exports.openKnowMoreLink = exports.openInsertAdLink = exports.openAdPageLink = exports.openAccountsLoginLink = void 0;
var _platform = require("../platform");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var openLink = exports.openLink = function openLink(webUrl) {
  var targetSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (webUrl) {
    var url = webUrl;
    if (_typeof(webUrl) === 'object' && webUrl.web) {
      url = webUrl.web;
    }
    if (typeof url === 'function') {
      url();
      return;
    }
    if (targetSelf || _platform.isMsite) {
      window.location = url;
    } else {
      window.open(url, '_blank');
    }
  }
};
var openKnowMoreLink = exports.openKnowMoreLink = function openKnowMoreLink() {
  var REACT_APP_KNOW_MORE = "https://ajuda.olx.com.br/s/article/termos-uso-do-chat";
  openLink(REACT_APP_KNOW_MORE);
};
var openInsertAdLink = exports.openInsertAdLink = function openInsertAdLink(lurker) {
  var REACT_APP_IA_URL = "https://www2.olx.com.br/ai/form/0";
  if (REACT_APP_IA_URL) {
    lurker.clickAdviceInsertAd();
    openLink("".concat(REACT_APP_IA_URL, "?referral=chat"));
  }
};
var openAccountsLoginLink = exports.openAccountsLoginLink = function openAccountsLoginLink(listId) {
  var REACT_APP_ACCOUNTS_LOGIN = "https://conta.olx.com.br/acesso";
  if (REACT_APP_ACCOUNTS_LOGIN) {
    openLink(REACT_APP_ACCOUNTS_LOGIN + (listId ? "?action_type=CHAT_VI&list_id=".concat(listId) : ''), true);
  }
};
var openUserProfileLink = exports.openUserProfileLink = function openUserProfileLink(paramUrl, lurker) {
  var REACT_APP_BASE_USER_PROFILE_URL = "https://www.olx.com.br/perfil";
  if (paramUrl && REACT_APP_BASE_USER_PROFILE_URL) {
    lurker.clickViewUserProfile();
    openLink("".concat(REACT_APP_BASE_USER_PROFILE_URL, "/").concat(paramUrl, "?lis=chat"));
  }
};
var openResearchPlatformEvolution = exports.openResearchPlatformEvolution = function openResearchPlatformEvolution(chatId, accountId, lurker) {
  var REACT_APP_RESEARCH_PLATFORM_EVOLUTION = undefined;
  if (REACT_APP_RESEARCH_PLATFORM_EVOLUTION) {
    lurker.clickAskProfileVerification(chatId, accountId);
    openLink("".concat(REACT_APP_RESEARCH_PLATFORM_EVOLUTION, "?chat_id=").concat(chatId) + "&account_id=".concat(accountId));
  }
};
var openAdPageLink = exports.openAdPageLink = function openAdPageLink(listId) {
  var REACT_APP_BASE_AD_URL = "https://olx.com.br/vi";
  if (REACT_APP_BASE_AD_URL) {
    openLink("".concat(REACT_APP_BASE_AD_URL, "/").concat(listId));
  }
};
var openPhoneValidationLink = exports.openPhoneValidationLink = function openPhoneValidationLink(listId) {
  var returningTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'CHAT_VI';
  var REACT_APP_BASE_PHONE_VALIDATION_URL = "https://conta.olx.com.br/confirmacao-telefone";
  openLink("".concat(REACT_APP_BASE_PHONE_VALIDATION_URL) + "?action_type=".concat(returningTo, "&list_id=").concat(listId), true);
};
var openProfileValidationLink = exports.openProfileValidationLink = function openProfileValidationLink(url) {
  window.location.replace(url, true);
};